import { lazy } from 'react'

export const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'))
